import { render } from "./SuperAdminDatatableTDClinicPayStatus.vue?vue&type=template&id=8e62790c"
import script from "./SuperAdminDatatableTDClinicPayStatus.vue?vue&type=script&lang=js"
export * from "./SuperAdminDatatableTDClinicPayStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__